import { GraphQLClient } from 'graphql-request';
import { FileLocationEnum } from 'src/generated/graphql-types';
import { UserRolesEnum } from 'src/types.d';
import { graphQLRequest } from '../graphQL/graphQLRequestModule';
import { getInvestorDraftProjectFundFilesQuery } from '../graphQL/queries/investorPortal/viewAs/getInvestorDraftFiles';

/**
 * Gets all the files of the given entities and the personal files if includePersonalFiles is true
 * @param token Auth token
 * @param client GraphQL client
 * @param ids Ids of the entities to fetch (projects, operator and funds)
 * @param locationType Location type of the files
 * @returns All public files of the given entities filtered by the given tag
 */
export async function getInvestorDraftProjectFundFiles(
  token: string,
  client: GraphQLClient,
  ids: string[], //projects, funds, portfolios, offerings
  locationType?: FileLocationEnum,
): Promise<any> {
  //create input variable for the GQL request
  const input: any = {
    //todo idan why tasks are failing - fix the any
    ids,
    locationType,
  };
  let variables = {
    input,
  };

  //send GQL request for the files data
  const res = await graphQLRequest(
    token,
    client,
    getInvestorDraftProjectFundFilesQuery,
    variables,
    UserRolesEnum.operator,
  );

  //return the files
  return res?.getInvestorDraftProjectsFundsFiles ?? [];
}
